import Comm from '../services/comm';

export default{
    namespaced: true,
    state: {
        token: null,
        userid: null,
        username: null,
        roles: null,
        loading: false,
        error: null
    },
    getters: {
        isLogged(state){
            if(state.userid !== null && state.username !== null && state.roles !== null){
                return true;
            }
            return false;
        },
        getUser(state){
            return {
                userid: state.userid,
                username: state.username,
                roles: state.roles
            }
        },
        isAdmin(state){
            if(state.roles !== null){
                return state.roles.indexOf('admin') > -1;
            }
            return false;
        }
    },
    mutations: {
        setLogin(state, data){
            state.token = data.token;
            state.userid = data.id;
            state.username = data.username;
            state.roles = data.roles;
        }
    },
    actions: {
        login(context, data){
            context.state.error = null;
            context.state.loading = true;
            Comm.postData('login.php', { data: data}).then(res => {
                let response = res.data;
                if(response.status == 'ok'){
                    context.commit('setLogin', response.data);
                } else {
                    switch(response.error_type){
                        case 'invalid_login':
                            context.state.error = 'Hibás felhasználónév vagy jelszó!';
                            break;
                    }
                }
                context.state.loading = false;
            }).catch(error => {
                console.log(error);
                context.state.error = 'Hiba történt a bejelentkezés során!';
                context.state.loading = false;
            });
        },
        logout(context){
            context.state.error = null;
            context.state.loading = true;
            context.commit('setLogin', {
                token: null,
                id: null,
                username: null,
                roles: null
            });
            document.cookie = 'auth=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            context.state.loading = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/loginStore.js